import { Record } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';

const keys: Fields = {
  error: undefined,
  view: undefined,
  persistant: false,
};

interface Fields {
  error?: ErrorRecord;
  view: any;
  persistant: boolean;
}

export default class UnhandledErrorRecord extends Record<Fields>(keys) {}
